module.exports = __webpack_public_path__ + "img/white-arrow.91b05769.svg";